module.exports = "<div class=\"loader-outer\">\n    <div class=\"loader loader-content\">\n    <div class=\"lds-ellipsis\" style=\"text-align:center\">\n      <div></div>\n      <div></div>\n      <div></div>\n      <div></div>\n    </div>\n  </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src3838036574/src/src/app/common/loader-gif/loader-gif.component.html
// module id = ../../../../../src/app/common/loader-gif/loader-gif.component.html
// module chunks = main